/* Loads Google Identity Services (accounts.google.com/gsi/client) on demand. */
const GSI_SRC = 'https://accounts.google.com/gsi/client';

export function ensureGsiLoaded() {
  return new Promise((resolve, reject) => {
    if (window.google?.accounts?.oauth2) {
      resolve();
      return;
    }
    let script = document.querySelector(`script[src="${GSI_SRC}"]`);
    if (!script) {
      script = document.createElement('script');
      script.src = GSI_SRC;
      script.async = true;
      document.head.appendChild(script);
    }
    script.addEventListener('load', () => resolve());
    script.addEventListener('error', () => reject(new Error('Could not load Google sign-in — check your connection.')));
  });
}
